// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SiteSharedEmailAddressUpsearchModel {
    static getAttributeTypeMap() {
        return SiteSharedEmailAddressUpsearchModel.attributeTypeMap;
    }
}
SiteSharedEmailAddressUpsearchModel.discriminator = undefined;
SiteSharedEmailAddressUpsearchModel.additionalProperties = false;
SiteSharedEmailAddressUpsearchModel.attributeTypeMap = [
    {
        "name": "emailAddressId",
        "baseName": "emailAddressId",
        "type": "number"
    },
    {
        "name": "emailAddressType",
        "baseName": "emailAddressType",
        "type": "ContactInfoPurposeType"
    },
    {
        "name": "address",
        "baseName": "address",
        "type": "string"
    },
    {
        "name": "language",
        "baseName": "language",
        "type": "string"
    },
];
//# sourceMappingURL=siteSharedEmailAddressUpsearchModel.js.map